import {theme_info} from './theme.js';

let dict = undefined;
export function label(label_id) {
    // Get the browser language and load the appropriate language file
    if (dict == undefined) {
        let lang = theme_info("lang")
        if (lang == undefined) {
            lang = navigator.language || navigator.userLanguage;
            lang = lang.split("-")[0];
        }
        try {
            dict = require(`./languages/${lang}.json`);
        } catch (e) {
            dict = require(`./languages/en.json`);
        }
    }
    return dict[label_id] ? dict[label_id] : label_id;
}